import React from 'react';
import { Section } from './ui/Section';
import { Trophy, CheckCircle2 } from 'lucide-react';
export function ProductOverview() {
  const categories = ['Fundamentos', 'WODs', 'HIIT & ABS', 'Programación', 'Objetivos', 'Gestión', 'Planificación', 'Variaciones', 'Fidelización', 'Crecimiento'];
  const levels = ['Inicial', 'Intermedio', 'Avanzado', 'Sin Equipamiento', 'HIIT & ABS', 'Cross Training'];
  return <Section bg="dark-900" className="relative overflow-hidden" data-id="element-324">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-lime-500/5 to-transparent pointer-events-none" data-id="element-325" />

      <div className="max-w-5xl mx-auto text-center" data-id="element-326">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-dark-800 border border-lime-500/30 mb-4 md:mb-8 shadow-[0_0_30px_rgba(204,255,0,0.15)]" data-id="element-327">
          <Trophy className="w-7 h-7 md:w-10 md:h-10 text-lime-500" data-id="element-328" />
        </div>

        <div className="inline-block px-3 py-1 md:px-4 md:py-1.5 rounded-full bg-lime-500/10 border border-lime-500/20 text-lime-400 font-bold tracking-widest text-xs md:text-sm mb-4 md:mb-6 uppercase" data-id="element-329">
          Sistema N°1 en Argentina
        </div>

        <h2 className="md:text-5xl lg:text-6xl font-display font-bold text-white mb-4 md:mb-6 text-[28px]" data-id="element-330">
          FUNCIONAL & CROSS 360™ <br data-id="element-331" />
          <span className="text-lime-500" data-id="element-332">MEGAPACK</span>
        </h2>

        <p className="text-lg md:text-2xl text-gray-300 font-medium mb-6 md:mb-12" data-id="element-333">
          6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
        </p>

        <div className="grid md:grid-cols-2 gap-3 md:gap-6 mb-8 md:mb-16 text-left" data-id="element-334">
          <div className="bg-dark-800 border border-dark-700 p-5 md:p-8 rounded-2xl" data-id="element-335">
            <div className="text-3xl md:text-4xl font-display font-bold text-white mb-1 md:mb-2" data-id="element-336">
              +300
            </div>
            <div className="text-lime-400 font-medium mb-2 md:mb-4 uppercase tracking-wide text-sm md:text-base" data-id="element-337">
              Páginas de contenido
            </div>
            <p className="text-gray-400 text-sm md:text-base" data-id="element-338">
              Estructurado y listo para aplicar desde hoy mismo en tu espacio.
            </p>
          </div>
          <div className="bg-dark-800 border border-dark-700 p-5 md:p-8 rounded-2xl" data-id="element-339">
            <div className="text-3xl md:text-4xl font-display font-bold text-white mb-1 md:mb-2" data-id="element-340">
              50+
            </div>
            <div className="text-lime-400 font-medium mb-2 md:mb-4 uppercase tracking-wide text-sm md:text-base" data-id="element-341">
              WODs completos
            </div>
            <p className="text-gray-400 text-sm md:text-base" data-id="element-342">
              Listos para dar, con progresiones, adaptaciones y tiempos.
            </p>
          </div>
        </div>

        <div className="mb-8 md:mb-16" data-id="element-343">
          <h3 className="text-lg md:text-xl font-bold text-white mb-4 md:mb-6 uppercase tracking-wider" data-id="element-344">
            Todo lo que incluye:
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-345">
            {categories.map((cat, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 bg-dark-800 border border-dark-700 rounded-lg text-gray-300 font-medium text-sm md:text-base" data-id="element-346">
                {cat}
              </span>)}
          </div>
        </div>

        <div className="bg-dark-800/50 border border-dark-700 p-5 md:p-12 rounded-3xl" data-id="element-347">
          <h3 className="text-xl md:text-2xl font-display font-bold text-white mb-5 md:mb-8" data-id="element-348">
            NIVELES Y ENFOQUES INCLUIDOS:
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-id="element-349">
            {levels.map((level, i) => <div key={i} className="flex items-center gap-2 md:gap-3 bg-dark-900 p-3 md:p-4 rounded-xl border border-dark-700" data-id="element-350">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-lime-500 flex-shrink-0" data-id="element-351" />
                <span className="text-white font-medium text-left text-sm md:text-base" data-id="element-352">
                  {level}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}